import { component_tool, framework_tool } from '../../../../tool';
let { WizModal, WizNotice } = component_tool;
import moment from "moment";
import React from 'react';
let { WizDataTable, WizIcon, WizButton, WizDivider, WizSurveyAudience, WizTypography, WizRow } = component_tool
let { WizAvatarUpload, ossFileUtils } = framework_tool


let ref;
//配置项
let componentName = 'liveStatistics'

const columns = [
  {
    name: "id",
    formItem: {
      type: "hidden"
    }
  },
  {
    name: "state",
    formItem: {
      type: "hidden"
    }
  },
  {
    title: "参训统计名称",
    name: "name",
    dataIndex: "name",
    searchItem: {},
    formItem: {
      maxlength: 50,
      placeholder: '请输入参训统计名称,最多输入50个字',
      rules: [{
        required: true,
        message: '请输入参训统计名称',
      }]
    },
    tableItem: {}
  },
  {
    title: "创建时间",
    name: "createTime",
    dataIndex: "createTime",
    tableItem: {}
  }

];

const templateConfig = (data)=>{
  const {entityId,entityType} = data;
  return {
  mainProps: {},
  content: {
    name: "WizTableList",
    params: {
      columns,
      searchBarProps: {
        buttonSort: ['add', 'delete',"updateTrainingStatistics"],
        buttons: [
          {
            key: "updateTrainingStatistics",
            custom: true,
            params: { icon: 'reload', children: '更新参训统计数据', type: 'reload'},
            customOnClick: {
              key: "action",
              params: {
                apiKey: "updateTrainingStatistics"
              },
              formatParams: (rows, record, filter) => {
                let id = null;
                if (rows && rows instanceof Array) {
                  rows.forEach(element => {
                    id=element.id
                  });
                }
                return {
                  id: id
                };
              }
            },
            recordChangeParams: ({ record, rows }) => {
              let disabled = 0;
              if (rows && rows instanceof Array && (rows.length===0 || rows.length>1)){
                disabled=1;
              }
              return { disabled: disabled }
            }
          },
        ]
      },
      modalFormProps: {},
      dataTableProps: {
        rowKey: "id",
        selectType: "checkbox",
        isScroll: true,
        loading: false,
      },
      rowOperateSort: ['update','assessmentRulesManagement','viewTrainingResult'],
      rowOperateView: [
        // {
        //   key: "edit",
        //   custom: true,
        //   params: { children: "编辑" },
        //   customOnClick: {
        //     key: "jumpPage",
        //     params: {
        //       key: "push",
        //       pathname: "/live/liveList/lookPositionInfo"
        //     }
        //   }
        // },
        {
          key: "assessmentRulesManagement",
          custom: true,
          params: { children: "考核规则管理" },
          customOnClick: {
            key: "jumpPage",
            params: {
              key: "push",
              pathname: "/live/liveList/liveStatisticsList/assessmentRulesList",
              record: {entityId,entityType}
            }
          }
        },
        {
          key: "viewTrainingResult",
          custom: true,
          params: { children: "查看参训统计" },
          customOnClick: {
            key: "jumpPage",
            params: {
              key: "push",
              pathname: "/live/liveList/liveStatisticsList/liveTrainReport",
              // record: {entityId}
            }
          }
        }
      ],
      commonOperate: {}
    }
  }
}
};




let reduxTemplateCofig = (args) => {
  const {entityId} = args;
  const apis = {
    list: {
      path: `${componentName}/listByPage`,
      payload: {
        key: `${componentName}@listByPage`,
        apiParams: {entityId,entityType:1,type:1}
      }
    },
    add: {
      path: `${componentName}/add`,
      payload: {
        key: `${componentName}@add`,
        apiParams: {entityId,entityType:1,state:0,type:1}
      }
    },
    update: {
      path: `${componentName}/update`,
      payload: {
        key: `${componentName}@update`,
        apiParams: {entityId,entityType:1,type:1}
      }
    },
    delete: {
      path: `${componentName}/delete`,
      payload: {
        key: `${componentName}@delete`,
        apiParams: {}
      }
    },
    export: {
      path: `${componentName}/export`,
      payload: {
        key: `${componentName}@listByCondition`,
        apiParams: {entityId,entityType:1,type:1}
      }
    },
    syncLiveRecord: {
      path: `${componentName}/syncLiveRecord`,
      payload: {
        key: `${componentName}@syncLiveRecord`,
        apiParams: {id:entityId}
      }
    },
    updateTrainingStatistics: {
      path: `${componentName}/updateTrainingStatistics`,
      payload: {
        key: `${componentName}@updateTrainingStatistics`,
        apiParams: {}
      }
    }
  }
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    keepInitApiParams: true,
    ...args
  }
};

export { reduxTemplateCofig, templateConfig };
